
/**
 * TMS-15768 Due date extension history DTO
 * Parent Task: TMS-14954 Due date management logic implementation
 */
export class DueDateExtensionHistoryDTO {
    PendingProposalId: number;
    RevisedDueDate: Date;
    IsByTeslaUser: boolean;
    ExistingDueDate: Date;
    ShipDate: Date;
    Reason: string;
    AdHocDueDateExtensionRequestStatusId: number;
    RequestedTo: number;
    EngineerUserName: string;
    EngineerEmail: string;
    CreatedByUserName: string;
    ModifiedByUserName: string;
    CreatedBy: number;
    CreatedOn: Date;
    ModifiedBy: number;
    ModifiedOn: Date;
    IsAdhocRequest: boolean;

    constructor() {
    }
}
